import sectionTextWithButtonCss from '../css-snippets/section-text-with-button';

const html = `
<style>${sectionTextWithButtonCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#9cdbe8"
  data-top-padding="true" data-bottom-padding="true" data-color="#07476e" data-text-color="#07476e"
  style="background-color: #9cdbe8; color: #07476e; --color-text: #07476e; --color-background: #9cdbe8; --btn-text-color: #ffffff; --btn-background-color: #214a88;">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div class="wrap-card">
        <div data-show-title="true" data-attribute="title-card" class="title-card">
          <h2 style="text-align:center;">Subscribe and get a Glass Infuser Bottle for $29.99 FREE</h2>
          <p style="text-align:center;">Place your order of Vital Beauty on subscription today and you’ll save 20% plus
            get a free borosilicate glass infuser bottle for on-the-go hydration.</p>
        </div>
        <a data-show-btn="true" href="#" class="btn-card" data-attribute="btn-card" data-background="#214a88"
          data-color="#ffffff" style="background-color: #214a88; color: #ffffff;">Shop Now</a>
      </div>
    </div>
  </div>
</div>
`;
export default html;
